import type {GpsSource} from "@/src/modules/core/types/geolocation";
import type {
  VehicleFuelLevel,
  VehicleServiceRequestId,
} from "@/src/modules/company-vehicles/types";

export enum BreakAction {
  START = "start",
  COMPLETE = "complete",
  DELAY = "delay",
  INTERRUPT = "interrupt",
  REJECT = "reject",
  TAKEN = "taken",
}

export type ShiftStartRequest = {
  shift_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
  date?: string;
  time?: string;
  officer_teams_and_conditions_acknowledged?: number;
};

/** Body returned by `POST shift/start` (under top-level `data` when the API uses an envelope). */
export type ShiftStartResponseData = {
  shift_id: number;
  worked_shift_id?: number;
  status?: string;
  actual_start_datetime?: string;
  message?: string;
  worked_shift?: unknown;
};

/** Nested end-phase vehicle check on `POST shift/end` (no `shift_id` or `phase`). */
export type ShiftEndVehicleConditionCheck = {
  company_vehicle_id: number;
  fuel_level: VehicleFuelLevel;
  mileage: number;
  condition_notes?: string | null;
  issues_inside?: string | null;
  issues_outside?: string | null;
  service_requests: VehicleServiceRequestId[];
  files?: string[];
};

export type ShiftEndRequest = {
  shift_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
  vehicle_condition_check?: ShiftEndVehicleConditionCheck;
};

/** Body returned by `POST shift/end` (under top-level `data` when the API uses an envelope). */
export type ShiftEndResponseData = {
  shift_id: number;
  worked_shift_id?: number;
  status?: string;
  tokens_revoked: boolean;
  vehicle_condition_check_id?: number;
};

export type BreakActionRequest = {
  shift_break_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
  action: BreakAction;
  delay_minutes?: number;
  reason?: string;
};

export type ExtendShiftRequest = {
  shift_id: number;
  extension_minutes: number;
};
